// extracted by mini-css-extract-plugin
export default {"profile__img":"Introduction_profile__img__1T5-g","introduction":"Introduction_introduction__AhOQx","title":"Introduction_title__T3Ezk","intro__btn":"Introduction_intro__btn__LWa8z"};